/* eslint-disable */
export default {
  hide: '非表示',
  end: '終了',
  keypad: 'キーパッド',
} as const;

// @key: @#@"hide"@#@ @source: @#@"Hide"@#@
// @key: @#@"end"@#@ @source: @#@"End"@#@
// @key: @#@"keypad"@#@ @source: @#@"Keypad"@#@
